import { useEffect, useState } from "react";
import { POLL_STATES } from "../../../../AppConstants/PollStates";
import LoaderImg from "../../../../assets/images/Loader.gif";
import styles from "./index.module.scss";

const PollQuestion = (props) => {
  const { handleSubmit, checkIfAlreadyAnswered } = props;
  const { options, id } = props.data;

  options.sort(function (a, b) {
    return a.id - b.id;
  });

  const [answer, setAnswer] = useState(checkIfAlreadyAnswered);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (checkIfAlreadyAnswered) {
      setAnswer(checkIfAlreadyAnswered);
    }
  }, [checkIfAlreadyAnswered]);

  const handleSubmitButton = (e) => {
    e.preventDefault();

    if (!answer) {
      setShowError(true);
      return;
    }
    handleSubmit(props.data, answer);
  };

  return (
    <form onSubmit={handleSubmitButton} className={checkIfAlreadyAnswered ? styles.disabledPointer : ""}>
      {options.map((option) => (
        <div key={`option-${option.id}`} className={styles.pollOption}>
          <label key={`checkbox-${option.id}`} className="">
            <input
              id={`checkbox-${option.id}`}
              type="radio"
              name={option.id}
              checked={!answer ? false : option.id === answer.id}
              onChange={(e) => {
                setShowError(false);
                setAnswer(option);
              }}
            //   disabled={checkIfAlreadyAnswered === null ? false : true}
            />
            {option.value}
          </label>
        </div>
      ))}
      {showError && (
        <div className={styles.error}>
          * Please give some response first, to submit.
        </div>
      )}
      <button
        type="submit"
        className={`btn ${styles.showResult}`}
        disabled={checkIfAlreadyAnswered === null ? false : true}
      >{`${checkIfAlreadyAnswered === null ? "Submit" : "Answered"}`}</button>
    </form>
  );
};
const PollResult = (props) => {
  const { index: currentIndex } = props;
  const { options, totalResponse } = props.data;

  options.sort(function (a, b) {
    return a.id - b.id;
  });

  return (
    <div className={styles.pollOption}>
      {options.map((option) => (
        <div className={styles.bgDiv}>
          <div
            className={styles.progress}
            style={{
              width: `${
                totalResponse > 0 ? (option.response / totalResponse) * 100 : 0
              }%`,
            }}
          />
          <div className={styles.value}>{option.value}</div>
          <div className={styles.percent}>
            {totalResponse > 0
              ? (option.response / totalResponse).toFixed(2) * 100
              : 0}
            %
          </div>
        </div>
      ))}
      {totalResponse && (
        <div className={styles.votesValue}>{totalResponse} Votes</div>
      )}
    </div>
  );
};

const Polls = ({ data, pollAnswerredData, submitResponse }) => {
  return (
    <div className={styles.pollsWrapper}>
      {!data && (
        <div className={styles.loader}>
          <img src={LoaderImg} alt="loading..." />
        </div>
      )}
      {data && data.length === 0 && (
        <div className={styles.noVisiblePoll}>
          As soon as a poll is posted <br></br>you will be able to express your
          opinion.
        </div>
      )}

      {data &&
        data.length !== 0 &&
        data.map((pollItem, index) => (
          <div key={index} className={styles.pollCard}>
            <div>{pollItem.question}</div>
            {pollItem.status === POLL_STATES.showQuestion && (
              <PollQuestion
                data={pollItem}
                handleSubmit={submitResponse}
                checkIfAlreadyAnswered={pollAnswerredData[pollItem.id]}
              />
            )}
            {pollItem.status === POLL_STATES.showResult && (
              <PollResult data={pollItem} index={index} />
            )}
          </div>
        ))}
    </div>
  );
};

export default Polls;
